import { TimeFrameForm } from '../dto/timeFrameForm';
import { ChartContainer } from './chart-container.model';

export class ChartModel {
    id: number;
    guid: string;
    chartDataGuid: string;
    chartData?: any;
    chartError: number;
    name: string;
    createdDate: Date;
    viewCount?: number;
    groupCount?: number;
    timeFrame? : TimeFrameForm;
    containerGuid? : string;
    container?: ChartContainer;
}

export enum ChartType {
    text,
    line = 1,
    bar,
    pie,
    donut,
    horizontalBar,
    lineBar,
    stackedBar,
    // treeMap
}